/** `#rgb` or `#rrggbb`, with or without padding, as lower-case `#rrggbb`; undefined otherwise */
export function normalizeHexColor(color: string): string | undefined {
  const match = /^#?([0-9a-f]{3}|[0-9a-f]{6})$/i.exec(color.trim());
  if (!match) return undefined;

  const hex = match[1].toLowerCase();
  return `#${hex.length === 3 ? hex.replace(/./g, (c) => c + c) : hex}`;
}

/**
 * The shade of `color` for `count` tiers on a ramp that runs from white at 0
 * to `color` itself at `max`, linearly per channel. Counts above `max` get the
 * colour; `max` below 1 is taken as 1. The ramp is relative to the vessel: the
 * caller passes the tallest stack on board, so a 7-tier ship uses the whole
 * range just like a 12-tier one.
 *
 * A colour that is not hex falls back to a mid grey rather than throwing in the
 * middle of a render.
 */
export function tiersShadeColor(color: string, count: number, max: number): string {
  const base = normalizeHexColor(color) ?? "#808080";
  const top = Math.max(1, Math.floor(max));
  const t = Math.min(top, Math.max(0, count)) / top;

  const channel = (from: number) => {
    const value = Math.round(255 + (parseInt(base.slice(from, from + 2), 16) - 255) * t);
    return (value < 16 ? "0" : "") + value.toString(16);
  };

  return `#${channel(1)}${channel(3)}${channel(5)}`;
}
